import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';

const AES_IV_STRING = process.env.VUE_APP_API_SECRETIV;
const SECRET_KEY = process.env.VUE_APP_API_SECRETKEY;

// 加密
export const encryptCBC = (data) => {
  const plaintext = typeof data === 'string' ? data : JSON.stringify(data);
  const key = Utf8.parse(SECRET_KEY);
  const ivBytes = Utf8.parse(AES_IV_STRING);

  const encrypted = AES.encrypt(plaintext, key, {
    iv: ivBytes
    // mode: 默认就是 CBC
    // padding: 默认就是 PKCS7
  });
  return {
    data: encrypted.toString() // base64 字符串
  };

};
// 解密
export const decryptCBC = (encryptedBase64) => {
  const key = Utf8.parse(SECRET_KEY);
  const ivBytes = Utf8.parse(AES_IV_STRING);

  const decrypted = AES.decrypt(encryptedBase64.data.data, key, {
    iv: ivBytes
  });

  return {
    ...encryptedBase64,
    data: JSON.parse(decrypted.toString(Utf8))
  };
};